import { useState } from 'react'
import { useSpendContext } from './useSpendContext';
import { ApiUrl } from '../services'
import { axiosInstance as axios } from '../AxiosToken';
import { manageErrorPigApi, sleep } from '../utils';

export const useDeleteExpense = () => {
  const { dispatch } = useSpendContext()
  const [error, setError] = useState(null)
  const [response, setResponse] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const deleteExpense = async (id) => {
    setIsLoading(true)
    setError(null)
    let url = ApiUrl()
    let path = 'expenses'

    try {
      if(id){
        path += `/${id}`
      }
      let lnk = `${url}/api/${path}`
      if (process.env.NODE_ENV !== 'production') {
        const sleepDuration = 100
        console.group('Delete Request')
        console.log('useDelete: ', lnk);
        // console.log('data: ', JSON.stringify(data));
        // console.table(data)
        await sleep(sleepDuration)
        console.warn(`SLEEP ${sleepDuration}ms Enabled in useDeleteExpense.jsx`)
        console.groupEnd()
      }
      const respAxios = await axios.delete(lnk)
      let result = respAxios.data
      // console.log('getExpenses Responses Axios', result)
      setResponse(result)
      setIsLoading(false)
        dispatch({type:'REFRESH_EXPENSES', payload: result.expenses})
        dispatch({
          type: 'SET_NOTIF', payload: {
            message: 'Dépense Supprimée !',
            type: 'success'
          }
        })
      } catch (error) {
      let errorMessage = manageErrorPigApi(error)
      setError(error)
      dispatch({
        type: 'SET_NOTIF', payload: {
          message: (errorMessage) ? errorMessage : error.message,
          type: 'error'
        }
      })
      setIsLoading(false)
    }
  }
  return { deleteExpense, isLoading, error, response }
}


